import { createFileRoute, Link } from "@tanstack/react-router";
import { H2, H3, LegalLayout, List, ProviderAddress } from "../components/legal-layout";
import { provider } from "../legal/provider";

export const Route = createFileRoute("/datenschutz")({ component: Datenschutz });

function Datenschutz() {
  return (
    <LegalLayout title="Datenschutzerklärung">
      <H2>1. Verantwortlicher</H2>
      <p>Verantwortlich für die Datenverarbeitung auf dieser Website und in der App ist:</p>
      <ProviderAddress />
      <p>E-Mail: {provider.email}</p>

      <H2>2. Worum es geht – und worum nicht</H2>
      <p>
        archinventory ist eine Software für Architekturbüros zur Inventarisierung von Möbeln
        (Web-App und Android-App). Die Nutzung ist nur auf Einladung möglich.
      </p>
      <p>
        Diese Erklärung beschreibt, wie wir personenbezogene Daten verarbeiten, wenn Sie die Website
        oder App aufrufen und ein Benutzerkonto nutzen.{" "}
        <strong>
          Für die Inhalte, die ein Büro in archinventory erfasst (Kunden, Projekte, Räume, Inventar,
          Fotos), ist das jeweilige Büro Verantwortlicher.
        </strong>{" "}
        Wir verarbeiten diese Inhalte nur in dessen Auftrag und nach dessen Weisung auf Grundlage
        eines Vertrags zur Auftragsverarbeitung (Art. 28 DSGVO). Fragen dazu richten Sie bitte an
        das Büro, für das Sie archinventory nutzen.
      </p>

      <H2>3. Hosting und Zugriffsdaten</H2>
      <p>
        Website, App-Schnittstelle (API) und Dateispeicher werden bei Cloudflare, Inc. (USA)
        betrieben. Fotos (Cloudflare R2) und die Echtzeit-Funktionen (Durable Objects) sind auf die
        EU-Jurisdiktion festgelegt. Anfragen werden über das weltweite Netz von Cloudflare
        ausgeliefert.
      </p>
      <p>
        Bei jedem Aufruf werden technisch notwendige Daten verarbeitet: IP-Adresse, Datum und
        Uhrzeit, aufgerufene Adresse, Browser bzw. App-Version und Betriebssystem. Das ist
        erforderlich, um die Dienste sicher und stabil bereitzustellen (Art. 6 Abs. 1 lit. f DSGVO).
      </p>
      <p>
        Cloudflare ist unter dem EU-U.S. Data Privacy Framework zertifiziert; zusätzlich gelten die
        EU-Standardvertragsklauseln. [prüfen: aktueller Stand der Zertifizierung]
      </p>

      <H2>4. Benutzerkonto</H2>
      <p>Für Ihr Konto verarbeiten wir:</p>
      <List>
        <li>Name und E-Mail-Adresse,</li>
        <li>Ihr Passwort, ausschließlich als kryptografischer Hash,</li>
        <li>Ihre Rolle und Ihre Zugehörigkeit zu einem oder mehreren Büros,</li>
        <li>
          Anmeldesitzungen mit IP-Adresse und Browser- bzw. Gerätekennung; eine Sitzung läuft nach
          spätestens 30 Tagen ab.
        </li>
      </List>
      <p>
        Rechtsgrundlage ist die Erfüllung des Vertrags mit Ihnen bzw. dem Büro, für das Sie
        archinventory nutzen (Art. 6 Abs. 1 lit. b DSGVO), sowie unser berechtigtes Interesse an
        einem sicheren Betrieb (Art. 6 Abs. 1 lit. f DSGVO).
      </p>

      <H2>5. Einladungen und E-Mails</H2>
      <p>
        Wir versenden ausschließlich E-Mails, die für die Nutzung nötig sind: Einladungen,
        Bestätigungen und Links zum Zurücksetzen des Passworts. Der Versand erfolgt über den
        E-Mail-Dienst von Cloudflare. Wird jemand eingeladen, verarbeiten wir dessen E-Mail-Adresse
        im Auftrag des einladenden Büros.
      </p>

      <H2>6. Sicherheit und Nachvollziehbarkeit</H2>
      <List>
        <li>
          Zum Schutz vor Missbrauch (z. B. automatisierten Anmeldeversuchen) begrenzen wir die
          Anzahl der Anfragen pro IP-Adresse. Die dafür gespeicherten Zähler werden nur kurzfristig
          benötigt. [prüfen: Löschfrist]
        </li>
        <li>
          Änderungen an Inventardaten werden mit Zeitpunkt und Benutzer protokolliert, damit ein
          Büro nachvollziehen kann, wer was geändert hat. [Aufbewahrungsdauer ergänzen]
        </li>
      </List>

      <H2>7. Datenbank</H2>
      <p>
        Konten und Inventardaten werden in einer PostgreSQL-Datenbank bei Neon gespeichert,
        betrieben in einem Rechenzentrum von Amazon Web Services in Frankfurt am Main. [prüfen:
        Vertragspartner und Übermittlungsgrundlage gemäß Neon-AVV]
      </p>

      <H2>8. Fotos</H2>
      <p>
        Fotos werden im Auftrag des Büros gespeichert und nur über signierte, zeitlich begrenzte
        Links angezeigt. Fotos können unbeabsichtigt Personen, Bildschirme oder Whiteboards zeigen.
        Das Büro ist dafür verantwortlich, solche Aufnahmen zu vermeiden oder zu löschen. Exporte
        (ZIP-Dateien mit Excel-Liste und Fotos) liegen nach dem Herunterladen in der Verantwortung
        des Büros.
      </p>

      <H2>9. Automatische Bildauswertung (KI)</H2>
      <p>
        Derzeit nicht aktiv. Sobald aktiviert, werden Fotos zur Vorbefüllung der Inventarfelder an
        ein KI-Modell (Google Gemini über Google Cloud Vertex AI) in einer EU-Region übermittelt,
        über das AI Gateway von Cloudflare. Die Auswertung erfolgt im Auftrag des Büros; die
        Ergebnisse werden von Menschen geprüft. [prüfen und ergänzen, bevor die Funktion aktiviert
        wird: Vertragspartner, Region, Speicherung, keine Nutzung zum Training]
      </p>

      <H2>10. Fehleranalyse</H2>
      <p>
        Um Fehler zu erkennen und zu beheben, nutzen wir Sentry (Functional Software, Inc., USA) mit
        Datenspeicherung in der EU. Übermittelt werden technische Fehlerinformationen (z. B.
        Fehlermeldung, Gerätetyp, App-Version). Personenbezogene Daten wie IP-Adressen werden nicht
        bewusst übermittelt; sensible Werte werden automatisch entfernt. Rechtsgrundlage ist unser
        berechtigtes Interesse an einem fehlerfreien Betrieb (Art. 6 Abs. 1 lit. f DSGVO). [prüfen:
        Übermittlungsgrundlage gemäß Sentry-AVV]
      </p>

      <H2>11. Cookies und lokale Speicherung</H2>
      <p>
        Wir verwenden nur ein technisch notwendiges Cookie für Ihre Anmeldung (§ 25 Abs. 2 Nr. 2
        TDDDG). Es gibt keine Analyse-, Tracking- oder Werbe-Cookies und keine Einbindung von
        Drittanbietern zu Werbezwecken.
      </p>

      <H2>12. Android-App</H2>
      <List>
        <li>
          Die App benötigt Zugriff auf die Kamera, um Inventar zu fotografieren. Fotos werden bis
          zum erfolgreichen Hochladen auf dem Gerät zwischengespeichert.
        </li>
        <li>Ihr Anmeldetoken wird im geschützten Speicher des Geräts abgelegt.</li>
        <li>Die App enthält keine Werbung und kein Tracking.</li>
      </List>

      <H2>13. Speicherdauer</H2>
      <p>
        Wir speichern personenbezogene Daten nur so lange, wie es für die genannten Zwecke nötig
        ist. Kontodaten löschen wir, wenn das Konto bzw. der Vertrag mit dem Büro endet, soweit
        keine gesetzlichen Aufbewahrungspflichten bestehen. Inhalte eines Büros werden nach
        Vertragsende gemäß dem Vertrag zur Auftragsverarbeitung gelöscht.
      </p>

      <H3>Empfänger</H3>
      <p>
        Daten erhalten nur die oben genannten Dienstleister, die wir als Auftragsverarbeiter
        einsetzen, sowie innerhalb eines Büros die Personen, die das Büro eingeladen hat.
      </p>

      <H2>14. Ihre Rechte</H2>
      <p>Sie haben das Recht auf</p>
      <List>
        <li>Auskunft (Art. 15 DSGVO),</li>
        <li>Berichtigung (Art. 16 DSGVO),</li>
        <li>Löschung (Art. 17 DSGVO),</li>
        <li>Einschränkung der Verarbeitung (Art. 18 DSGVO),</li>
        <li>Datenübertragbarkeit (Art. 20 DSGVO),</li>
        <li>
          Widerspruch gegen Verarbeitungen auf Grundlage berechtigter Interessen (Art. 21 DSGVO).
        </li>
      </List>
      <p>
        Wenden Sie sich dazu an {provider.email}. Betrifft Ihr Anliegen Inhalte eines Büros, leiten
        wir es an das Büro weiter. Sie können sich außerdem bei einer Datenschutz-Aufsichtsbehörde
        beschweren (Art. 77 DSGVO), zum Beispiel bei der für uns zuständigen:{" "}
        {provider.supervisoryAuthority}.
      </p>

      <p>
        Siehe auch: <Link to="/nutzungsbedingungen">Nutzungsbedingungen</Link> ·{" "}
        <Link to="/impressum">Impressum</Link>
      </p>
    </LegalLayout>
  );
}
